export default __webpack_public_path__ + "static/tech-grafana-8a1edfed75528afa4fd2f82c7c73c299-8a1edfed75528afa4fd2f82c7c73c299.png";